import script from "./BreadcrumbNav.vue?vue&type=script&setup=true&lang=js"
export * from "./BreadcrumbNav.vue?vue&type=script&setup=true&lang=js"

import "./BreadcrumbNav.vue?vue&type=style&index=0&id=5364bd1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5364bd1b"]])

export default __exports__